import ReportsLayout from './reports-layout'
import { useParams } from 'react-router-dom'
import MonthlyCommissionReport from './monthly-commission-report'
import FastboundDiffReport from './fastbound-diff-report'
import AccountsWithoutSubscriptionsReport from './accounts-without-subscriptions-report'
import AccountsWithDuplicateSubscriptionsReport from './accounts-with-duplicate-subscriptions-report'
import ChargebeeSubscriptionsWithoutAccountsReport from './chargebee-subscriptions-without-accounts-report'
import AccountsWithChargebeeSubscriptionsReport from './accounts-with-chargebee-subscriptions-report'
import AccountsWithFastboundSubscriptionsReport from './accounts-with-fastbound-subscriptions-report'
import BackupToolReport from './backup-tool-report'

const REPORT_LINKS = [
    { label: 'Monthly Commission', href: '/reports/monthly-commission', category: 'Billing' },
    { label: 'Fastbound diff', href: '/reports/fastbound-diff', category: 'Subscriptions' },
    { label: 'Backup Tool Status', href: '/reports/backup-tool', category: 'Backup Tool' },
]

export default function ReportsPage() {
    const { reportType } = useParams()

    if (reportType === 'monthly-commission') {
        return (
            <ReportsLayout title='Reports' subtitle='Explore analytics and insights' reports={REPORT_LINKS}>
                <MonthlyCommissionReport />
            </ReportsLayout>
        )
    }

    if (reportType === 'fastbound-diff') {
        return (
            <ReportsLayout title='Reports' subtitle='Explore analytics and insights' reports={REPORT_LINKS}>
                <FastboundDiffReport />
            </ReportsLayout>
        )
    }

    if (reportType === 'accounts-without-subscriptions') {
        return <ReportsLayout title='Reports' subtitle='Explore analytics and insights' reports={REPORT_LINKS}>
            <AccountsWithoutSubscriptionsReport />
        </ReportsLayout>
    }
    if (reportType === 'accounts-with-duplicate-subscriptions') {
        return <ReportsLayout title='Reports' subtitle='Explore analytics and insights' reports={REPORT_LINKS}>
            <AccountsWithDuplicateSubscriptionsReport />
        </ReportsLayout>
    }
    if (reportType === 'chargebee-subscriptions-without-accounts') {
        return <ReportsLayout title='Reports' subtitle='Explore analytics and insights' reports={REPORT_LINKS}>
            <ChargebeeSubscriptionsWithoutAccountsReport />
        </ReportsLayout>
    }
    if (reportType === 'accounts-with-chargebee-subscriptions') {
        return <ReportsLayout title='Reports' subtitle='Explore analytics and insights' reports={REPORT_LINKS}>
            <AccountsWithChargebeeSubscriptionsReport />
        </ReportsLayout>
    }
    if (reportType === 'accounts-with-fastbound-subscriptions') {
        return <ReportsLayout title='Reports' subtitle='Explore analytics and insights' reports={REPORT_LINKS}>
            <AccountsWithFastboundSubscriptionsReport />
        </ReportsLayout>
    }

    if (reportType === 'backup-tool') {
        return (
            <ReportsLayout title='Reports' subtitle='Explore analytics and insights' reports={REPORT_LINKS}>
                <BackupToolReport />
            </ReportsLayout>
        )
    }

    return (
        <ReportsLayout title='Reports' subtitle='Explore analytics and insights' reports={REPORT_LINKS}>
            <div className='text-sm text-muted-foreground'>Select a report from the left to begin.</div>
        </ReportsLayout>
    )
}